import CLIENT from '../utils/CUP'

export const MODULE_NAME = 'BULK_ACTION_STATUS_CONTROLLER';

function namespaced(name) {
    return MODULE_NAME + '.' + name;
}

const CLEAR_OPERATIONS = namespaced('CLEAR_OPERATIONS');
const GET_OPERATIONS = namespaced('GET_OPERATIONS');
const GET_OPERATIONS_OK = namespaced('GET_OPERATIONS_OK');
const GET_OPERATIONS_FAIL = namespaced('GET_OPERATIONS_FAIL');

export const ACTION_TYPES = {
    CLEAR_OPERATIONS,
    GET_OPERATIONS,
    GET_OPERATIONS_OK,
    GET_OPERATIONS_FAIL
};

const initialState = {
    operations: [],
    loading: false,
    error: null
};

export const bulkActionStatusReducer = (state = initialState, action) => {

    switch (action.type) {
        case ACTION_TYPES.CLEAR_OPERATIONS:
            return {
                ...state,
                operations: [],
                error: null
            };
            
        case ACTION_TYPES.GET_OPERATIONS:
            return {
                ...state,
                loading: true,
                error: null
            };
            
        case ACTION_TYPES.GET_OPERATIONS_OK:
            return {
                ...state,
                operations: Array.isArray(action.response) ? action.response : [],
                loading: false,
                error: null
            };
            
        case ACTION_TYPES.GET_OPERATIONS_FAIL:
            return {
                ...state,
                operations: [],
                loading: false,
                error: action.error
            };
            
        default:
            return state;
    }
};

export const API = {
    getOperations: (tenantId, userId, operationTypeIds, successCallback, failureCallback) => {
        return async (dispatch) => {
            dispatch({ type: ACTION_TYPES.CLEAR_OPERATIONS });
            dispatch({ type: ACTION_TYPES.GET_OPERATIONS });
            
            try {
                const response = await CLIENT.getBulkOperationStatus(tenantId, userId, operationTypeIds);
                
                dispatch({ 
                    type: ACTION_TYPES.GET_OPERATIONS_OK, 
                    response: response?.value || []
                });
                
                if (typeof successCallback === 'function') {
                    successCallback(response);
                }
            } catch (error) {
                dispatch({ 
                    type: ACTION_TYPES.GET_OPERATIONS_FAIL, 
                    error 
                });
                
                if (typeof failureCallback === 'function') {
                    failureCallback(error);
                }
            }
        };
    }
};